import NewButton from "./newButton";
import { ButtonTypes } from "../../Definitions";
import { colors, frames } from "../../Styles";

interface TableButtonProps {
  content: string;
  startEnhancer: string | JSX.Element;
  onClick: () => void;
  disabled: boolean;
  bottomPosition?: number;
  leftPosition?: number;
  gridArea?: string;
}

const TableButton = ({ content, startEnhancer, onClick, disabled, gridArea, bottomPosition = 180, leftPosition = -5}: TableButtonProps) => {

  return (
    <frames._grid_bluePrintButton_container
      style={{ bottom: `${bottomPosition}px`, left: `${leftPosition}px` }}
    >
      <NewButton
        content={content}
        startEnhancer={startEnhancer}
        buttonType={ButtonTypes.textButton}
        overrides={{
          baseStyles: {
            backgroundColor: colors.greySecondary,
            padding: "6px 8px",
            borderRadius: "8px 8px 0 0",
            userSelect: "none",
            height: "fit-content",
            borderWidth: "0px 0px 5px 0px",
            borderColor: colors.greySecondary,
            borderStyle: "solid"
          },
          hoverStyles: { backgroundColor: colors.greyPrimary, borderColor: colors.greyPrimary, opacity: "1" },
          startEnhancerStyles: { transform: "rotate(-45deg)" },
        }}
        onClick={onClick}
        disabled={disabled}
      />
    </frames._grid_bluePrintButton_container>
  );
};

export default TableButton;
